import { createPortal } from 'react-dom';
import {

  ModalContent,
  ModalOverlay,
  CloseBtn,
} from './ModalViewDoc.styled';
import { ScrollBox } from '../Modal/Modal.styled';
import { useRef } from 'react';
const modalRoot = document.querySelector('#root-module');

const ModalViewDoc = ({ children, onClose, pad, heightT = false }) => {
  const handleContentClick = event => {
    event.stopPropagation();
  };
 const shouldClose = useRef(false);

  const handleMouseDown = (e) => {
    shouldClose.current = e.target === e.currentTarget;
  };
 const handleMouseUp = (e) => {
    if (
      shouldClose.current &&
      e.target === e.currentTarget
    ) {
      onClose();
    }

    shouldClose.current = false;
  };

  return createPortal(
    <ModalOverlay  onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}>
      <ModalContent pad={pad} onClick={handleContentClick} heightT={heightT ? 'true' : 'false'} >
 <ScrollBox pad={pad} >
        {pad !== "false" && <CloseBtn onClick={onClose} />}

        {children}
                </ScrollBox>
      </ModalContent>
    </ModalOverlay>,
    modalRoot
  );
};

export default ModalViewDoc;
